export type ButtonVariant =
  | "primary"
  | "secondary"
  | "outline"
  | "cta"
  | "form"
  | "dialog";

export class AppButton extends HTMLElement {
  constructor() {
    super();
  }

  // Se ejecuta automáticamente cuando el componente se inserta en el DOM
  connectedCallback() {
    this.render();
  }

  // Método para observar cambios en los atributos
  static get observedAttributes() {
    return ["text", "variant", "type", "disabled"];
  }

  get disabled() {
    return this.hasAttribute("disabled");
  }

  set disabled(val) {
    if (val) {
      this.setAttribute("disabled", "");
    } else {
      this.removeAttribute("disabled");
    }
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  render() {
    const text = this.getAttribute("text") || "Botón";
    const variant: ButtonVariant =
      (this.getAttribute("variant") as ButtonVariant) || "primary";
    const type = this.getAttribute("type") || "button";
    const isDisabled = this.disabled;

    // Clases base de Tailwind — diseño pill (redondeado completo)
    let classes =
      "px-5 md:px-12 py-2 font-bold rounded-full shadow-lg active:scale-[0.98] transition-all duration-150 flex items-center justify-center whitespace-nowrap ";

    if (variant === "primary") {
      classes += "bg-[#00298C] hover:bg-[#001b3d] text-[#C5EFFF] ";
    } else if (variant === "secondary") {
      classes += "bg-[#0ea5e9] hover:bg-[#0284c7] text-white ";
    } else if (variant === "outline") {
      classes +=
        "bg-transparent border-2 border-white text-white hover:bg-white/10 ";
    } else if (variant === "cta") {
      classes +=
        "bg-[#C5EFFF] hover:bg-[#a8dfff] text-[#00298C] text-xl md:text-2xl ";
    } else if (variant === "form") {
      classes += "form-pill ";
    } else if (variant === "dialog") {
      classes += "bg-[#00298C] hover:bg-[#001b3d] text-[#C5EFFF] text-[1.2rem]";
    }

    // Estado visual de deshabilitado manejado internamente
    if (isDisabled) {
      classes += "opacity-50 cursor-not-allowed active:scale-100 ";
    }

    this.innerHTML = `
            <button type="${type}" class="${classes}" ${isDisabled ? "disabled" : ""}>
                ${text}
            </button>
        `;
  }
}

// Registrar el Web Component en el navegador
if (typeof window !== "undefined") {
  customElements.define("app-button", AppButton);
}
